"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NewRelicPageActionService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var NewRelicPageActionService = /** @class */ (function () {
    function NewRelicPageActionService() {
    }
    NewRelicPageActionService.prototype.addPageAction = function (name, attributes) {
        var _a, _b;
        if (!window.newrelic) {
            console.info('`window.newrelic` is unavailable, unable to add page action');
            return;
        }
        try {
            (_b = (_a = window.newrelic) === null || _a === void 0 ? void 0 : _a.addPageAction) === null || _b === void 0 ? void 0 : _b.call(_a, name, __assign({ locationHash: window.location.hash.toLowerCase(), callStack: new Error().stack || '' }, attributes));
        }
        catch (error) {
            console.info(error);
        }
    };
    NewRelicPageActionService = __decorate([
        (0, CommonService_decorator_1.CommonService)('NewRelicPageActionService')
    ], NewRelicPageActionService);
    return NewRelicPageActionService;
}());
exports.NewRelicPageActionService = NewRelicPageActionService;
//# sourceMappingURL=NewRelicPageAction.service.js.map